export default function jump(form: HTMLFormElement, pageLoad = false)
{
    let jumps = form.querySelectorAll('.jump-headings');
    
    if(jumps.length > 0) {
        let id = [];

        for(let field of jumps) {
            if(field instanceof HTMLInputElement) {
                id.push(field.value);
            }
        }

        let jumpid = id.join(':');

        let heading = document.getElementById(jumpid);

        if(heading) {
            let firstHeading = document.querySelector('.wp-block-taxonomy-filter-results>.wp-block-heading');

            if(!pageLoad || heading != firstHeading) {
                heading.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            }
        }
    }
}